module.exports = __webpack_public_path__ + "assets/media/arrow-acc.e9414164.svg";